import React from 'react';
import classnames from 'classnames';
import ProgressSlider from './progressSlider';
import InfoIcon from 'images/icons/info.svg?react-svg';
import {
  uppercase,
  secondary,
  sansSerifMedium,
  sansSerifLight,
  fontSizeS,
  lineHeightM,
  letterSpacingL
} from 'scy/text/styles.mod.scss';
import { ExtraLightHR } from 'scy/HR';
import { pointsToNextStatus } from './helpers';
import { textCenter } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function LoyaltyStatusDetails({
  title,
  description,
  currentPoints,
  statusTiers,
  nextStatus
}) {
  return (
    <section
      className={classnames(
        padding.left_md,
        padding.right_md,
        padding.bottom_lg,
        textCenter
      )}
    >
      <h1
        className={classnames(
          fontSizeS,
          sansSerifMedium,
          letterSpacingL,
          uppercase,
          margin.xs
        )}
      >
        {title}
      </h1>

      <p
        className={classnames(
          sansSerifLight,
          secondary,
          fontSizeS,
          lineHeightM,
          margin.sm
        )}
      >
        {description}
      </p>

      <ExtraLightHR
        thick
        marginClass={classnames(margin.top_md, margin.bottom_md)}
      />

      <p
        className={classnames(
          sansSerifMedium,
          secondary,
          fontSizeS,
          lineHeightM,
          margin.sm
        )}
      >
        {nextStatus
          ? pointsToNextStatus(currentPoints, nextStatus)
          : 'Perks & Benefits'}{' '}
        <a href="/loyalty-program-benefits" className={margin.left_xxs}>
          <InfoIcon width={15} height={15} />
        </a>
      </p>

      {!!nextStatus && (
        <ProgressSlider
          currentPoints={currentPoints}
          nextStatus={nextStatus}
          statusTiers={statusTiers}
        />
      )}
    </section>
  );
}
